import paketApi from '../../services/paketApi'

const SET_PAKET = "SET_PAKET"
const SET_PAKET_SELECTED = "SET_PAKET_SELECTED"

const state = {
	paket: null,
	paketSelected: null
}

const mutations = {
	[SET_PAKET](state, data) {
		state.paket = data
	},
	[SET_PAKET_SELECTED](state, data) {
		state.paketSelected = data
	}
}

const actions = {
	async fetchPaket({ commit, getters }) {
		let token = getters.getAuthService.token
		return await paketApi.fetchPaket(token).then(res => {
			if (res.data.status) {
				commit(SET_PAKET, res.data.data)
			}
		})
	},
	async fetchPaketPublic({ commit, getters }) {
		let token = getters.getAuthService.token
		return await paketApi.fetchPaketPublic(token).then(res => {
			if (res.data.status) {
				commit(SET_PAKET, res.data.data)
			}
		})
	},
	async searchPaketAndLayananPublic({ commit, getters }, data) {
		return await paketApi.searchPaketAndLayananPublic(data)
	},
	async showPaketPublic({ commit }, slug) {
		return await paketApi.showPaketPublic(slug).then(res => {
			if (res.data.status) {
				commit(SET_PAKET_SELECTED, res.data.data)
			}
		})
	},
	selectPaket({ commit }, data) {
		commit(SET_PAKET_SELECTED, data)
	},
	setPaket({ commit }, data) {
		commit(SET_PAKET, data)
	},
	async updatePaket({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await paketApi.updatePaket(token, data.id, data.form)
	},
}

const getters = {
	getPaket: state => {
		return state.paket
	},
	getSelectedPaket: state => {
		return state.paketSelected
	}
}

export default {
	state,
	mutations,
	actions,
	getters
}